export default "__VITE_ASSET__BRbl699K__"